<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs10, sm9, md8, lg8, text-xs-center)
          v-card(flat)
            breadcrumb(back='page6-20')
            v-card-text.label16tt.withDivider(style='margin-top:-58px;')
              | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
            v-card-text.titulo36Book.pa-0.ma-0.pb-5
              | ¡Quiero contratar mi Crédito Hipotecario!
            v-card-media(height='300px', src='assets/TCH-L2.7-8-9-portada.jpg')
            v-card-text.parrafoDestacado18.text-xs-left
              | ¡Ya conoces los principales aspectos de un Crédito Hipotecario! El siguiente paso es validar si el inmueble que deseas adquirir cumple con los requisitos necesarios y conocer los requerimientos que tú debes cubrir, así como personalizar los elementos clave que aprendiste antes. A continuación, encontrarás una lista con la que podrás completar dicha tarea y visualizar el plan ideal para ti.
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage('page7-2')")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    }
  },
};
</script>
